import React from 'react';
import ClassManagementComponent from '../../../components/admin/class/ClassManagementComponent';

const ClassManagement: React.FC = () => {
  return <ClassManagementComponent />;
};

export default ClassManagement;
